const type = 'standard'
const path = 'client/html'
const name = 'app.js'
const fullPath = `${path}/${name}`

export { type, path, name, fullPath }
